/**
 * @author gll
 * 模块说明：用户中心-组织模块
 */
import { Service } from '@/tools'

export class PostService<T extends TUser.Post> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TUser.Post}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：组织中心/岗位管理/添加岗位用户
   * /api/user/post/v1/addUser
   */
  addUser = <K extends T['ApiAddUser']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddUser', data)

  /**
   * 功能：组织中心/岗位管理/分批查询岗位列表
   * /api/user/post/v1/page
   */
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  /**
   * 功能：组织中心/岗位管理/查看岗位成员
   * /api/user/post/v1/user
   */
  user = <K extends T['ApiUser']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUser', data)

  /**
   * 功能：组织中心/岗位管理/删除岗位
   *  /api/user/post/v1/delete
   */
  delete = <K extends T['ApiDelete']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDelete', data)

  /**
   * 功能：组织中心/岗位管理/编辑组织岗位
   *  /api/user/post/v1/update
   */
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data)

  /**
   * 功能：组织中心/岗位管理/新增组织岗位
   *  /api/user/post/v1/add
   */
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)

  /**
   * 功能：组织中心/.../查询组织下面岗位下拉框
   *  /api/user/post/v1/dropDownList
   */
  dropDownList = <K extends T['ApiDropDownList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDropDownList', data)
}
